import { initializeTimePanelData } from '../actions/timePanelDndStoreActions';
import { doNothingOnDrop } from '../utils/doNothingOnDrop';
import { observer } from 'mobx-react-lite';
import { DragData, DraggableItemTypes, Droppable } from 'owa-dnd';
import * as React from 'react';
import {
    getTimePanelDropState,
    isTimePanelDataInitialized,
} from '../selectors/timePanelDndStoreSelectors';

import * as styles from './TimePanelDropListener.scss';

export interface TimePanelDropListenerProps {
    children?: React.ReactNode;
}

/**
 * This component handles listening for items being dragged over Time Panel
 * and accordingly modifying the store to show the drop hint.
 */
export default observer(function TimePanelDropListener(props: TimePanelDropListenerProps) {
    const { children } = props;

    return (
        <Droppable
            classNames={styles.timePanelDropListener}
            dropViewState={getTimePanelDropState()}
            onDragEnter={onDragEnter}
            onDrop={doNothingOnDrop}
            canDrop={canDropItemType}
            greedy={true}>
            {children}
        </Droppable>
    );
});

function onDragEnter() {
    if (!isTimePanelDataInitialized()) {
        initializeTimePanelData();
    }
}

/* "global" canDrop for the Time Panel that accepts any DraggableItemType that is consumed by a component within Time Panel */
function canDropItemType(dragInfo: DragData): boolean {
    return (
        dragInfo.itemType === DraggableItemTypes.MailListRow ||
        dragInfo.itemType === DraggableItemTypes.Todo
    );
}
